import React from 'react';
import { AppBar, Toolbar, Box, Typography } from '@mui/material';
import AccountMenu from './AccountMenu';

/**
 * Top bar for the pages a user sees as themselves (Dashboard, Account): logo,
 * the product title, and the shared account menu.
 *
 * The counterpart to StaffAppBar, and deliberately not a variant of it. What
 * separates them is not styling but audience: this bar says "FiStone Financial
 * Planning" where StaffAppBar says "FiStone Admin Dashboard" and wears the ADMIN
 * chip. Folding the two into one component behind a flag would put the admin
 * branding one mistaken prop away from a customer's own account page, which is
 * exactly the bug this pair was split to prevent.
 *
 * The menu itself is not part of that split. It is the same list of places this
 * account can go whichever page it is opened from, so it lives in AccountMenu
 * and gates its own admin entries on can_view_admin_dash — a permission a
 * customer does not hold.
 *
 * Self-contained rather than prop-driven, matching StaffAppBar: the title and
 * menu do not vary by page, so there is nothing for a caller to parameterise.
 * Page-specific chrome — Account's breadcrumb — renders below this bar inside
 * the page's own Container.
 */
function UserAppBar() {
  return (
    <AppBar position="static">
      <Toolbar>
        <Box
          component="img"
          sx={{
            height: 40,
            width: 40,
            mr: 2,
          }}
          alt="FiStone Logo"
          src="/fistone-logo.png"
        />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          FiStone Financial Planning
        </Typography>
        <AccountMenu />
      </Toolbar>
    </AppBar>
  );
}

export default UserAppBar;
